// Orden de presentación para catálogos (SRS-01 §8) — alfabético con
// localeCompare (correcto con acentos), salvo "tier" que usa orden
// numérico natural (T1, T2 ... T10) en vez de alfabético puro.
export function compararValorCatalogo(a: string, b: string, tipo: string): number {
  if (tipo === 'tier') {
    return a.localeCompare(b, 'es', { numeric: true, sensitivity: 'base' });
  }
  return a.localeCompare(b, 'es', { sensitivity: 'base' });
}

export function ordenarCatalogo<T extends { valor: string }>(items: T[], tipo: string): T[] {
  return [...items].sort((a, b) => compararValorCatalogo(a.valor, b.valor, tipo));
}
